import { render, staticRenderFns } from "./TagSelect.vue?vue&type=template&id=28e6d075"
import script from "./TagSelect.vue?vue&type=script&lang=js"
export * from "./TagSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports